"use client";

import { withFallback } from "../with-fallback";

export const TreasuryBreakdownElement = withFallback({
	displayName: "TreasuryBreakdownElement",
	type: "treasury-breakdown-element",
} as const);
